import {
  Button,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Show,
  Image,
} from "@chakra-ui/react";
// import Image from "next/image";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
interface SearchProps {
  onSearch: (t: string) => void;
}

const Search = ({ onSearch }: SearchProps) => {
  const [search, setSearch] = useState<string>("");
  const router = useRouter();

  useEffect(() => {
    setSearch("");
    onSearch("");
  }, [router]);

  const handleSearch = (text: string) => {
    setSearch(text);
    onSearch(text);
  };

  return (
    <>
      <Show above="lg">
        <InputGroup
          bg="#F5F5F5"
          w="584px"
          h="56px"
          borderRadius="48px"
          mt="24px"
        >
          <InputLeftElement h="56px">
            <Image
              src="/assets/images/search.svg"
              alt=""
              boxSize="24px"
              ml="24px"
            />
          </InputLeftElement>

          <Input
            placeholder="Search here..."
            value={search}
            onChange={(e) => handleSearch(e.target.value)}
            h="56px"
            paddingLeft="50px"
            borderRadius="48px"
            _hover={{ borderColor: "#AEDFCA" }}
            _placeholder={{
              color: "rgba(20, 37, 40, 0.3)",
              fontSize: "14px",
              fontWeight: "500",
            }}
            _focus={{ borderColor: "#AEDFCA" }}
          />

          <InputRightElement h="56px" mr="5px" w="92px">
            <Button h="48px" minW="92px" borderRadius="40px">
              Search
            </Button>
          </InputRightElement>
        </InputGroup>
      </Show>
      <Show below="lg">
        <InputGroup
          bg="#F5F5F5"
          w="328px"
          h="58px"
          borderRadius="48px"
          mt="24px"
        >
          <Input
            placeholder="Search here..."
            value={search}
            onChange={(e) => handleSearch(e.target.value)}
            h="58px"
            borderRadius="48px"
            _hover={{ borderColor: "#AEDFCA" }}
            _placeholder={{
              color: "rgba(20, 37, 40, 0.3)",
              fontSize: "14px",
              fontWeight: "500",
            }}
            _focus={{ borderColor: "#AEDFCA" }}
          />

          <InputRightElement h="58px" mr="17px" w="92px">
            <Button
              h="46px"
              minW="111px"
              borderRadius="40px"
              fontSize="14px"
              fontWeight="700"
            >
              Search
            </Button>
          </InputRightElement>
        </InputGroup>
      </Show>
    </>
  );
};

export default Search;
